export const FeatureFlagValue = Object.freeze({
  ON: 'on'
})

export class FeatureFlag {
  /** @type {string} */
  #enabledValue
  /** @type {string} */
  #name

  constructor (name, enabledValue) {
    this.#name = name
    this.#enabledValue = enabledValue || FeatureFlagValue.ON
  }

  get name () {
    return this.#name
  }

  get enabledValue () {
    return this.#enabledValue
  }
}
